import { render, staticRenderFns } from "./ContactEditExtraFields.vue?vue&type=template&id=05a53f8a"
import script from "./ContactEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./ContactEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a53f8a')) {
      api.createRecord('05a53f8a', component.options)
    } else {
      api.reload('05a53f8a', component.options)
    }
    module.hot.accept("./ContactEditExtraFields.vue?vue&type=template&id=05a53f8a", function () {
      api.rerender('05a53f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditExtraFields.vue"
export default component.exports